export const PAGES_SIZES_FOR_PROMOS = [
    {
        name: 'A4',
        code: 'A4',
    },
    {
        name: 'A4 1/4 Portrait',
        code: 'A4QuarterPortrait',
    },
    {
        name: 'A4 1/4 Landscape',
        code: 'A4QuarterLandscape',
    },
    {
        name: 'A4 1/8',
        code: 'A4EighthPortrait',
    },
    {
        name: 'A4 1/9',
        code: 'A4NinthLandscape'
    }
]